module.exports = __webpack_public_path__ + "static/img/vip-offline-bg.bc13911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/vip-offline-bg.png
// module id = E3GK
// module chunks = 212